import * as React from "react";
const SvgSpinningLoader = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", style: {
  margin: "auto",
  background: "none",
  display: "block",
  shapeRendering: "auto",
  animationPlayState: "running",
  animationDelay: "0s"
}, width: "48px", height: "48px", viewBox: "0 0 100 100", preserveAspectRatio: "xMidYMid", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 50, cy: 50, r: 30, stroke: "#efefef", strokeWidth: 8, fill: "none", style: {
  animationPlayState: "running",
  animationDelay: "0s"
} }), /* @__PURE__ */ React.createElement("circle", { cx: 50, cy: 50, r: 30, stroke: "#0987f2", strokeWidth: 8, strokeLinecap: "round", fill: "none", style: {
  animationPlayState: "running",
  animationDelay: "0s"
} }, /* @__PURE__ */ React.createElement("animateTransform", { attributeName: "transform", type: "rotate", repeatCount: "indefinite", dur: "1s", values: "0 50 50;180 50 50;720 50 50", keyTimes: "0;0.5;1", style: {
  animationPlayState: "running",
  animationDelay: "0s"
} }), /* @__PURE__ */ React.createElement("animate", { attributeName: "stroke-dasharray", repeatCount: "indefinite", dur: "1s", values: "18.84955592153876 169.64600329384882;94.2477796076938 94.24777960769377;18.84955592153876 169.64600329384882", keyTimes: "0;0.5;1", style: {
  animationPlayState: "running",
  animationDelay: "0s"
} })));
export default SvgSpinningLoader;
